namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_group, {

		Count: {
			alignItems: 'center',
			justifyContent: 'center',
			minWidth: $mol_gap.block,
			padding: {
				left: $mol_gap.text,
				right: $mol_gap.text,
			},
			color: $mol_theme.shade,
		},

	} )
	
}
